import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["step", "firstName", "lastName", "yearLevel", "initial", "submit"]
  static values = { fallbackInitial: String }

  connect() {
    this.show(0)
    this.refreshSubmit()
  }

  next(event) {
    event.preventDefault()
    const current = this.currentIndex()
    if (current < this.stepTargets.length - 1) this.show(current + 1)
  }

  back(event) {
    event.preventDefault()
    const current = this.currentIndex()
    if (current > 0) this.show(current - 1)
  }

  updateInitial() {
    const value = this.firstNameTarget.value.trim()
    const letter = (value[0] || this.fallbackInitialValue || "").toUpperCase()
    if (this.hasInitialTarget) this.initialTarget.textContent = letter
    this.refreshSubmit()
  }

  refreshSubmit() {
    if (!this.hasSubmitTarget) return
    const filled = [this.firstNameTarget, this.lastNameTarget, this.yearLevelTarget]
      .every((el) => el && el.value && el.value.trim().length > 0)
    this.submitTarget.disabled = !filled
    this.submitTarget.setAttribute("aria-disabled", !filled)
  }

  currentIndex() {
    return this.stepTargets.findIndex((el) => !el.hidden)
  }

  show(index) {
    this.stepTargets.forEach((el, i) => { el.hidden = i !== index })
  }
}
